import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const resultAttributes = [
  // General.
  'url',

  // Taxonomy term.
  'tid',
  'taxonomy_name',
  'taxonomy_image_ratio_1_1_xxs',
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: 'taxonomy_weight',
    order: 'asc',
  },
};
